// Hand-crafted Phantom critiques. The Phantom is a failed 1985 cinema student.
// Pick a random line per flaw. If no flaws: pick a praise line.

const PRAISE = [
    "Hmph. Acceptable. Even a yearbook hack can stumble into greatness.",
    "...A clean negative. I almost miss the disappointment.",
    "Fine. You composed it correctly. Don't get used to applause.",
    "Sharp. Properly lit. I'd hang this in my locker if I had one.",
    "Adequate. Cartier-Bresson is rolling at a comfortable speed in his grave.",
];

const FLAW_LINES = {
    UNDER_EXPOSED: [
        "I cannot SEE it, you nincompoop! Open the aperture or drag the shutter!",
        "Black. Pitch BLACK. Did you photograph the inside of your lens cap?",
        "More LIGHT, child! The film is starving!",
    ],
    OVER_EXPOSED: [
        "BLINDING. You've burned the whole school's worth of paper for THAT?",
        "A white frame is not 'minimalism,' it is 'incompetence'.",
        "Too much light. Stop down. Stop UP. Stop BREATHING if you must.",
    ],
    MOTION_BLUR: [
        "A SMEAR. You photographed a ghost — its name is 'slow shutter'.",
        "The subject moved. So did your shutter. Faster, faster, FASTER.",
        "What is this — abstract expressionism? Freeze it. 1/250 or higher.",
    ],
    DOF_TOO_DEEP: [
        "Everything is sharp. EVERYTHING. The subject is drowning in clutter.",
        "Isolate the subject! Wider aperture, smaller f-number. Were you ASLEEP in class?",
        "f/8? For a key on the glass? Open up to f/2.8, you barbarian.",
    ],
    NOISE_HEAVY: [
        "Grain like sandpaper. ISO 6400 is a CRIME against silver halide.",
        "I can hear the pixels screaming from across the darkroom.",
        "You cranked the ISO to the ceiling. Of course it's a mess.",
    ],
    NOISE_TRIGGER: [
        "Too much grain. The rustle alerted... me.",
        "ISO 6400 in MY corridor? You may as well have rung a bell.",
        "Noise. Audible noise. I HEAR YOU.",
    ],
};

const INTROS = [
    "*tears the photograph slowly*",
    "*adjusts a 1985 thrift-store beret*",
    "*sniffs the developer fumes for inspiration*",
    "*lights a candle for cinema*",
    "*emerges from a fog of red light*",
];

export function pickCritique(result) {
    if (result.success && result.flaws.length === 0) {
        return {
            intro: pick(INTROS),
            line: pick(PRAISE),
            tone: "grudging",
        };
    }
    // priority order
    const order = ["OVER_EXPOSED", "UNDER_EXPOSED", "DOF_TOO_DEEP", "MOTION_BLUR", "NOISE_HEAVY", "NOISE_TRIGGER"];
    const primary = order.find(f => result.flaws.includes(f)) || result.flaws[0];
    return {
        intro: pick(INTROS),
        line: pick(FLAW_LINES[primary] || ["Mediocre. Mediocre and beneath cinema."]),
        tone: "scathing",
        primaryFlaw: primary,
    };
}

function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

export const FLAW_LABEL = {
    UNDER_EXPOSED: "Under-exposed",
    OVER_EXPOSED:  "Over-exposed",
    MOTION_BLUR:   "Motion blur",
    DOF_TOO_DEEP:  "Depth of field too deep",
    NOISE_HEAVY:   "Ruined by noise",
    NOISE_TRIGGER: "Audible noise — Phantom alerted",
};
